import { appliesToKind } from './baKindFields';
import type { DesignSectionKey } from './DesignSectionKey';
import { kindField, moduleField } from './designSections';
import type { IDesignSub } from './IDesignSub';

/**
 * Чи показувати колонку списку розділу «Проєктування» (прототип v4 dsgFixed і oneKind): модуль задано розділом — колонки немає; вид — лише
 * у «Мотивації · Усі», де видів кілька; для вкладки одного виду — лише поля, що стосуються цього виду (appliesToKind). Чиста функція.
 */
export function designColumnShown(section: DesignSectionKey, sub: IDesignSub, field: string): boolean {
  if (field === moduleField) return false;
  if (field === kindField) return section === 'motivation' && sub.kinds.length > 1;
  return sub.kinds.length !== 1 || appliesToKind(field, sub.kinds[0]!);
}
